/** Pure civil-date helpers. Dates are ISO `YYYY-MM-DD` strings in no particular timezone. */
function pad(n) {
    return n < 10 ? `0${n}` : String(n);
}
export function toISODate(y, m, d) {
    return `${y}-${pad(m)}-${pad(d)}`;
}
/** Parse `YYYY-MM-DD` to a UTC Date at midnight (used only for arithmetic, never for tz). */
export function parseISODate(date) {
    const [y, m, d] = date.split("-").map(Number);
    return new Date(Date.UTC(y, m - 1, d));
}
export function addDays(date, n) {
    const dt = parseISODate(date);
    dt.setUTCDate(dt.getUTCDate() + n);
    return toISODate(dt.getUTCFullYear(), dt.getUTCMonth() + 1, dt.getUTCDate());
}
/** Day of week for a civil date: 0=Sunday..6=Saturday. */
export function weekday(date) {
    return parseISODate(date).getUTCDay();
}
/** Easter Sunday (Gregorian) via Meeus/Jones/Butcher algorithm. */
export function computeEaster(year) {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    return toISODate(year, month, day);
}
/** French métropole public holidays for a year (Alsace-Moselle extras excluded). */
export function frPublicHolidays(year) {
    const easter = computeEaster(year);
    return new Set([
        toISODate(year, 1, 1), // Jour de l'an
        addDays(easter, 1), // Lundi de Pâques
        toISODate(year, 5, 1), // Fête du Travail
        toISODate(year, 5, 8), // Victoire 1945
        addDays(easter, 39), // Ascension
        addDays(easter, 50), // Lundi de Pentecôte
        toISODate(year, 7, 14), // Fête nationale
        toISODate(year, 8, 15), // Assomption
        toISODate(year, 11, 1), // Toussaint
        toISODate(year, 11, 11), // Armistice
        toISODate(year, 12, 25), // Noël
    ]);
}
export function isPublicHoliday(date) {
    const year = Number(date.slice(0, 4));
    return frPublicHolidays(year).has(date);
}
export function isWorkingDay(date) {
    const wd = weekday(date);
    if (wd === 0 || wd === 6)
        return false;
    return !isPublicHoliday(date);
}
//# sourceMappingURL=dates.js.map